<template>
    <menu_orders
        :key="'menu_orders'"
        :showOrdersMenu="showOrdersMenu"
    />
    <div v-if="showOrderInfo" class="order_main">
        <div class="order_main__wrapper">
            <order
                :key="'order_'+ activeOrderId"
                :isLoadFullInfo="isLoadFullInfo"
                :isLoadLogs="isLoadLogs"
                :isLoadStates="isLoadStates"
                :isOrder="isOrder"
                @click_back_arrow="clickBackArrow"
            />
        </div>
    </div>
    <modal
        v-if="statusModalQuestion"
        :key="'modal_window_select_time_' + activeOrderId"
    >
        <template v-slot:content>
            <modal_question
                :key="'modal_question' + activeOrderId"
                :actionButton="actionButton"
            />
        </template>
    </modal>

    <modal
        v-if="statusModalTime"
        :key="'modal_window_select_time_' + activeOrderId"
    >
        <template v-slot:content>
            <modal_time
                :key="'modal_select_time_' + activeOrderId"
                :arrayTime="arrayTime"
                :actionButton="actionButton"
            />
        </template>
    </modal>

    <modal
        v-if="statusModalNewOrder"
        :key="'modal_window_new_order_' + activeOrderId"
    >
        <template v-slot:content>
            <modal_new_order
                :key="'modal_new_order_' + activeOrderId"
                :newOrderIn="newOrderIn"
                @close_modal_new_order="closeModalNewOrder"
            />
        </template>
    </modal>

</template>

<script>

import menu_orders from "../menu/order/MenuOrders.vue";
import order from "./Order.vue";
import loader_page from "../loader/LoaderPage.vue";
import {screenSize} from "../../mixins/screenSize";
import modal from "../modal/Modal.vue"
import modal_time from "../modal/time/ModalTime.vue";
import modal_new_order from "../modal/new/ModalNewOrder.vue";
import {changeBody} from "../../mixins/changeBody";
import modal_left from "../modal/left/ModalLeft.vue";
import modal_question from "../modal/question/ModalQuestion.vue";
import {notificationMixin} from "../../mixins/notificationMixin";
import {createHelpers} from "vuex-map-fields";
import {getFullUrl} from "../../helpers/urlFunctions";
import toast_new_order from "../toast/ToastNewOrder.vue";
import {useToast} from "vue-toastification";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

const toast = useToast();

export default {
    name: "orders_page",
    props: {
        id_order: {
            type: String,
            required: false,
            default: null,
        }
    },
    components: {
        modal, modal_time, modal_new_order,
        loader_page,
        menu_orders,
        order,
        modal_left,
        modal_question,
        toast_new_order,
    },
    emits: [''],
    mixins: [screenSize, changeBody, notificationMixin],
    data() {
        return {
            isLoadFullInfo: true,
            isLoadLogs: true,
            isLoadLog: true,
            isLoadPos: true,
            isLoadSelectLocationsCount: true,
            isLoadLocationsCount: true,
            isLoadStates: true,
            isSelectOrder: false,
            statusModalTime: false,
            statusModalNewOrder: false,
            statusModalQuestion: false,
            modalTime: null,
            arrayTime: [{time: 2, isSelect: false}],
            newOrderIn: null,
            actionButton: null,
            soundNewOrder: new Audio('/sounds/go_order.mp3'),
        }
    },
    beforeMount() {
        const contentClear = document.querySelector('.content__container_clear');
        if (contentClear) {
            contentClear.parentNode.removeChild(contentClear);
        }
        this.$store.dispatch('user/STATE_LOAD_PAGE', true);
        if (this.id_order && this.isMobileScreen) {
            this.isSelectOrder = true;
        }
        EventBus.$on('new_order_in', this.newOrderEvent);
        EventBus.$on('view_new_order', this.viewNewOrder);
        EventBus.$on('close_modal_time', this.closeModalTime);
        EventBus.$on('click_modal_time', this.clickModalTime);
        EventBus.$on('change_modal_time', this.changeModalTime);
        EventBus.$on('accept_the_order', this.acceptOrder);
        EventBus.$on('click_question_modal', this.clickModalQuestion);


        EventBus.$on('load_menu_main', this.loadMenuMain);
        EventBus.$on('get_orders_pooling', this.loadGetOrdersPooling);
        EventBus.$on('get_order_full_info', this.loadOrderFullInfo);
        EventBus.$on('get_order_logs', this.loadOrderLogs);
        EventBus.$on('click_item_order_menu', this.clickItemOrderMenu);
        EventBus.$on('get_order_pos_state', this.loadOrderPosState);
        EventBus.$on('get_order_states', this.loadOrderStates);
        EventBus.$on('reload_orders_menu_current_order', this.reloadOrdersMenuAndOrder);
        EventBus.$on('change_state_order_event', this.changeStateOrderEvent);
    },
    mounted() {
        const removeTemplate = document.getElementById('template_orders_remove');
        if (removeTemplate) {
            removeTemplate.parentNode.removeChild(removeTemplate);
        }
    },
    beforeUnmount() {
        EventBus.$off('new_order_in', this.newOrderEvent);
        EventBus.$off('view_new_order', this.viewNewOrder);
        EventBus.$off('close_modal_time', this.closeModalTime);
        EventBus.$off('click_modal_time', this.clickModalTime);
        EventBus.$off('change_modal_time', this.changeModalTime);
        EventBus.$off('accept_the_order', this.acceptOrder);
        EventBus.$off('click_question_modal', this.clickModalQuestion);


        EventBus.$off('load_menu_main', this.loadMenuMain);
        EventBus.$off('get_orders_pooling', this.loadGetOrdersPooling);
        EventBus.$off('get_order_full_info', this.loadOrderFullInfo);
        EventBus.$off('get_order_logs', this.loadOrderLogs);
        EventBus.$off('click_item_order_menu', this.clickItemOrderMenu);
        EventBus.$off('get_order_pos_state', this.loadOrderPosState);
        EventBus.$off('get_order_states', this.loadOrderStates);
        EventBus.$off('reload_orders_menu_current_order', this.reloadOrdersMenuAndOrder);
        EventBus.$off('change_state_order_event', this.changeStateOrderEvent);
    },
    methods: {
        showNewOrder() {
            this.newOrderEvent(this.ordersNewList[0])
        },
        newOrderEvent(e) {
            this.newOrderIn = e;

            // this.statusModalNewOrder = true;
            // this.closeModalNewOrderAfterInterval(120);

            this.sendToastNewOrder();

            this.$store.dispatch('orders/SET_ACTIVE_NEW_ORDER_ID', e.id);
            try {
                if (this.isSettingLoopAudio) {
                    this.soundNewOrder.loop = true;
                }
                this.soundNewOrder.play();
            } catch (err) {
                console.log('don\'t play sound', err);
            }

            const settingsNotify = this.getNotifySettings(this.newOrderIn);
            if (settingsNotify) {
                this.showNotification(settingsNotify);
            }
        },
        stopSoundNewOrder() {
            this.soundNewOrder.pause();
            this.soundNewOrder.currentTime = 0;
        },
        sendToastNewOrder() {
            const content = {
                component: toast_new_order,
                props: {
                    newOrderIn: this.newOrderIn,
                    user: this.user,
                    ordersNewList: this.ordersNewList,
                    closeToast: (toastId) => {
                        this.$toast.dismiss(toastId);
                        this.stopSoundNewOrder();
                    }
                },
            }
            const options = {
                toastClassName: 'toast__new_order_custom_wrap',
                debug: true,
                icon: false,
                timeout: this.isSettingLoopAudio ? false : 120000,
                closeOnClick: false,
                hideProgressBar: true,
                closeButton: false,
            }
            this.$toast(content, options);
        },
        changeStateOrderEvent(e) {
            let idOrder = null;
            if (this.getObjectPathProperty(e, 'order.order.id') && this.getObjectPathProperty(e, 'state.status')) {
                idOrder = e.order.order.id;
                this.regTemplate = '(^|\\s)' + 'accept';
                let regex = new RegExp(this.regTemplate, 'gi');
                if (regex.test(e.state.status) && idOrder === this.newOrderId) {
                    this.closeModalNewOrder();
                }
            }
            const params = {
                user: this.user,
                setDefaultOrder: false,
                eventSend: false,
                idOrder: idOrder,
                newOrderIn: null,
                actionName: 'getOrdersPooling',
            }
            $store.dispatch('orders/GET_ORDERS_POOLING', params);
        },
        closeModalNewOrderAfterInterval(interval) {
            setInterval(this.closeModalNewOrder, interval * 1000);
        },

        getNotifySettings(orderIn) {
            let settings = {};
            settings.notifyOptions = {};
            if (orderIn && orderIn.id) {
                settings.urlOpen = getFullUrl('/orders/' + orderIn.id);
                settings.notifyOptions.silent = true;
                //settings.notifyOptions.requireInteraction = true;
                settings.title = `${this.__t('O.NEW_ORDER')}`;
                if (orderIn.order && orderIn.order.order_code && orderIn.cost && orderIn.cost.total) {
                    settings.notifyOptions.body = `${this.__t('O.NEW_ORDER_HAS_ARRIVED')}` + ' ' + orderIn.order.order_code + ' ' + `${this.__t('O.NEW_ORDER_HAS_ARRIVED')}` + ' ' + `${this.__t('O.IN_THE_AMOUNT')}` + ' ' + orderIn.cost.total + this.currencyUser + '.' + this.textOrder;
                    const itemNewOrderMenu = this.ordersNewList.find(item => item.order.id === orderIn.id);
                    if (itemNewOrderMenu && itemNewOrderMenu.aggregator && itemNewOrderMenu.aggregator.icon) {
                        settings.notifyOptions.icon = 'data:image/svg+xml,' + encodeURIComponent(itemNewOrderMenu.aggregator.icon);
                    }
                }
            }
            return settings;
        },
        openModalNewOrder() {
            this.changeBody({class: 'lock'});
            this.statusModalNewOrder = true;
        },
        closeModalNewOrder() {
            this.changeBody({class: ''});
            this.statusModalNewOrder = false;
        },
        changeModalTime(paramChange) {
            this.acceptOrder(paramChange);
        },
        acceptOrder(paramsAccept) {
            this.closeModalQuestion();
            const params = {
                user: this.user,
                itemButton: paramsAccept.itemButton,
                timeSelect: paramsAccept.timeSelect,
                actionName: 'changeOrderState',
            }
            this.$store.dispatch('orders/CHANGE_ORDER_STATE', params);
        },
        clickModalTime(itemButton) {
            this.closeModalQuestion();
            this.actionButton = itemButton;
            this.changeBody({class: 'lock'});
            if (this.actionButton && this.actionButton.max_minutes && this.actionButton.max_minutes > 1) {
                for (let i = 5; i <= this.actionButton.max_minutes; i += 5) {
                    this.arrayTime.push({time: i, isSelect: i === 10});
                }
            }
            this.statusModalTime = true;
        },
        closeModalTime() {
            this.arrayTime = [{time: 2, isSelect: false}];
            this.changeBody({class: ''});
            this.statusModalTime = false;
        },
        clickModalQuestion(itemButton) {
            this.changeBody({class: 'lock'});
            this.actionButton = itemButton;
            this.statusModalQuestion = true;
        },
        closeModalQuestion() {
            this.changeBody({class: ''});
            this.statusModalQuestion = false;
        },
        viewNewOrder(newOrder) {
            this.statusModalNewOrder = false;
            const itemNewOrderMenu = this.getItemOrderMenu(newOrder.id);
            if (itemNewOrderMenu) {
                $store.dispatch('orders/CLICK_MENU_ITEM_MENU_ORDERS', {item: itemNewOrderMenu});
            }
        },
        getItemOrderMenu(orderId) {
            const arrayListOrders = [
                this.ordersNewList,
                this.ordersInProgressList,
                this.ordersReadyList
            ];
            let orderItem = null;
            for (let list of arrayListOrders) {
                orderItem = list.find(item => item.order.id === orderId);
                if (!this.$isEmpty(orderItem)) {
                    break;
                }
            }
            return orderItem;
        },
        loadMenuMain() {
            const params = {
                user: this.user,
                setDefaultOrder: true,
                eventSend: true,
                idOrder: this.id_order,
                actionName: 'getOrdersPooling',
            }
            this.$store.dispatch('orders/GET_ORDERS_POOLING', params);
        },
        loadGetOrdersPooling() {



            const params1 = {
                user: this.user,
                eventSend: true,
                actionName: 'getOrderFullInfo',
            }
            this.$store.dispatch('orders/GET_ORDER_FULL_INFO', params1);

            const params2 = {
                user: this.user,
                eventSend: true,
                actionName: 'getOrderLogs',
            }
            this.$store.dispatch('orders/GET_ORDER_LOGS', params2);

            const params3 = {
                user: this.user,
                eventSend: true,
                actionName: 'getOrderPosState',
            }
            this.$store.dispatch('orders/GET_ORDER_POS_STATE', params3);

            const params4 = {
                user: this.user,
                eventSend: true,
                actionName: 'getOrderState',
            }
            this.$store.dispatch('orders/GET_ORDER_STATES', params4);
        },
        loadOrderFullInfo() {
            this.isLoadFullInfo = false;
            this.changeLoadPage();
        },
        loadOrderLogs() {
            this.isLoadLog = false;
            this.changeLogsState();
        },
        loadOrderPosState() {
            this.isLoadPos = false;
            this.changeLogsState();
        },
        changeLogsState() {
            if (!this.isLoadLog && !this.isLoadPos) {
                this.isLoadLogs = false;
                this.changeLoadPage();
            }
        },
        changeLoadPage() {
            if (!this.isLoadFullInfo && !this.isLoadLogs) {
                this.$store.dispatch('user/STATE_LOAD_PAGE', false);
                //EventBus.$emit('get_state_menu_main');
            }
        },
        clickItemOrderMenu(itemMenu) {
            this.isSelectOrder = true;
            this.isLoadFullInfo = true;
            this.isLoadLogs = true;
            this.isLoadStates = true;
            const params = {
                user: this.user,
                item: itemMenu,
                eventSend: true,
            }
            this.$store.dispatch('orders/CLICK_MENU_ITEM_MENU_ORDERS', params)
        },
        loadOrderStates() {
            this.isLoadStates = false;
        },
        reloadOrdersMenuAndOrder() {
            const params = {
                user: this.user,
                setDefaultOrder: false,
                eventSend: true,
                idOrder: this.id_order,
                nameAction: 'getOrdersPooling',
            }
            this.$store.dispatch('orders/GET_ORDERS_POOLING', params);
        },
        clickBackArrow() {
            this.isSelectOrder = false;
        },
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageLogin',
            'isLoadPage'
        ]),
        ...mAggregators([
            'countSelectLocations',
            'countLocations'
        ]),
        ...mOrders([
            'activeItemMenuOrders',
            'activeOrderFullInfo',
            'activeOrderLogs',
            'countOrders',
            'ordersNewList',
            'ordersReadyList',
            'ordersInProgressList',
            'activeOrderStates',
            'newOrderId',
        ]),
        activeOrderId() {
            if (this.activeOrderFullInfo && this.activeOrderFullInfo.id) {
                return this.activeOrderFullInfo.id;
            }
            return '';
        },
        isOrder() {
            if (this.activeItemMenuOrders !== null) {
                return true;
            }
            return false;
        },
        showOrdersMenu() {
            if ((this.isMobileScreen && !this.isSelectOrder) || !this.isMobileScreen) {
                return true;
            }
            return false;
        },
        showOrderInfo() {
            if ((this.isMobileScreen && this.isSelectOrder) || !this.isMobileScreen) {
                return true;
            }
            return false;
        },
        currencyUser() {
            if (this.user && this.user.currency_suffix) {
                return this.user.currency_suffix;
            }
            return '';
        },
        textOrder() {
            let textOrderNew = '';
            if (this.newOrderIn.is_market) {
                textOrderNew = `${this.__t('O.DELIVERY')}` + ', ';
            } else {
                textOrderNew = `${this.__t('O.PICKUP_FROM_THE_RESTAURANT')}` + ', ';
            }
            if (this.newOrderIn.is_pay_cache) {
                textOrderNew += `${this.__t('O.CASH')}` + '.'
            } else {
                textOrderNew += `${this.__t('O.CARD')}` + '.'
            }
            return textOrderNew;
        },
        isSettingLoopAudio() {
            if (this.user && this.user.cookieSettings) {
                const settingFilter = this.user.cookieSettings.filter(item =>
                    item.parameter = 'is_loop_audio' && item.state
                )
                if (settingFilter.length > 0) {
                    return true;
                }
            }
            return false;
        }
    },
}
</script>
